

import { Component, Vue, Prop } from 'vue-property-decorator'
import BaseClass from '../../virtual-class/baseClass'
import { UserModule } from '../../store/modules/user'
import api from '../../api'



@Component

export default class SelectRegion extends BaseClass {
  @Prop({ type: Array }) value!: any
  // 0 代表栋 1代表层 2代表区 3 代表网络 4 代表组 5代表设备 回显问题暂未解决 使用所有数据
  @Prop({ type: Number, default: 2 }) level!: number
  @Prop({ type: Boolean, default: false }) multiple!: boolean
  @Prop({ type: Boolean, default: false }) showAllLevels!: boolean
  @Prop({ type: Boolean, default: false }) filterable!: boolean
  @Prop({ type: String, default: '位置' }) placeholder!: string
  private isResetLoad: boolean = false
  private get selection() {
    return this.value
  }
  private set selection(val) {
    console.log(val,'val');

    this.$emit('input', val)
  }
  private props: any = {
    multiple: this.multiple,
    label: 'name',
    value: 'id',
    // lazy: this.level > 1,
    // lazyLoad: this.lazyLoad,
  }
  mounted() {
    // this.$refs.cascader.panel.activePath=[]
    // this.$refs.cascader.panel.loadCount= 0
    // this.$refs.cascader.panel.lazyLoad()
    // console.log(this.$refs.cascader)
 
  }
  private resetLoad() {
    this.isResetLoad = true
    this.$nextTick(() => {
      this.isResetLoad = false
    })
  }
  private lazyLoad(node: any, resolve: Function) {
    let { level, data = {} } = node
    console.log(this.level, level)
    // if (!this.selection.length) {
    //   // 模拟获取回显
    //   this.selection = this.selection
    // }
    // this.getLazyDate(node, resolve)
  }
    private focus(e){
      console.log(e);
      
    }
  private change(...arg: any) {
    console.log(...arg);

    this.$emit('change', arg)
  }

  private getLazyDate(node: any, resolve: Function, findLevel?: number) {
    let { level, data = {} } = node
    console.log(level);
    
    level = findLevel || level
    if (this.level < level) {
      resolve([])
      return
    }
    if (level < 3) {
      // const result = this.getDeepFind(UserModule.orgPosList, level)
      // if (result) {
      //   resolve(result.map((item: any) => ({
      //     name: item.name,
      //     id: item.id,
      //     leaf: this.level <= level,
      //   })))
      // } else {
      //   this.$message.error('获取位置失败')
      // }
      resolve()
    } else if (level === 3) {
      api.getPosNetworkList({ orgId: UserModule.orgInfo.orgId, posId: data.id }).then((res: any) => {
        console.log(res);
        
        const netList: any[] = res.netList
        const netSelct = netList.map((item: any) => ({
          name: item.aliasName,
          id: item.netId,
          leaf: this.level <= level,
        }))
        resolve(netSelct)
      }).catch(() => {
      })
    } else if (level === 4) {
     api.getPosNetworkGroupList({netId: data.id }).then((res: any) => {
      
        
        
        const devList: any[] = res.devList

        const devSelct = devList.map((item: any) => ({
          name: item.name,
          id: item.Id,
          groupId: item.groupId,
          leaf: this.level <= level,
        }))
        resolve(devSelct)
      }).catch(() => {
      })
    } else if (level === 5) {
       api.getNetworkDevList({ orgId: UserModule.orgInfo.orgId, netId: data.id }).then((res: any) => {
        const devList: any[] = res.devList

        console.log('devList' + devList)
        const devSelct = devList.map((item: any) => ({
          name: item.devName,
          id: item.devId,
          leaf: this.level <= level,
        }))
        resolve(devSelct)
      }).catch(() => {
      })
    }
  }
  private visibleChange(val:any,item:any) {
    console.log(val)

    this.$nextTick(() => {
      // 添加这段代码
         const $el = document.querySelectorAll(
        '.el-cascader-panel .el-cascader-node[aria-owns]'
      );
      Array.from($el).map((item) => item.removeAttribute('aria-owns'));
      if (item && item.visible !== undefined) {
        if (item.visibleChange) {
          item.visibleChange(e);
        }
        if (item.expandChange) {
          item.expandChange(e);
        }
      }
    })
    //   const $el = document.querySelectorAll('.el-cascader-panel .el-cascader-node[aria-owns]')
    //   Array.from($el).map((item) => item.removeAttribute('aria-owns'))
    // })
  }
    private elChange(val:any,item:any) {
    console.log(val)

    this.$nextTick(() => {
      // 添加这段代码
         const $el = document.querySelectorAll(
        '.el-cascader-panel .el-cascader-node[aria-owns]'
      );
      Array.from($el).map((item) => item.removeAttribute('aria-owns'));
      if (item && item.visible !== undefined) {
        if (item.visibleChange) {
          item.visibleChange(e);
        }
        if (item.expandChange) {
          item.expandChange(e);
        }
      }
    })
    
  }

  private getDeepFind(arr: any[], num: number) {
    const deepMap = (item: any, index: number, _arr: any[]) => {
      if (item.level < num) {
        return {
          name: item.name,
          id: item.id,
          children: item.children.map(deepMap),
        }
      } else {
        return {
          name: item.name,
          id: item.id,
        }
      }
    }
    const findResult = arr.map(deepMap)
    return findResult
  }
  private get options() {
    if (this.$refs.cascader) {
      this.resetLoad()
    }
    console.log('options', this.getDeepFind(UserModule.orgPosList, this.level));
    
    return this.getDeepFind(UserModule.orgPosList, this.level)

    // return this.getDeepFind(UserModule.orgPosListByElectric, this.level)
  }
}
